import axios from "axios";
import toast from 'react-hot-toast';
import * as process from "process";
import store from '../store'
import {userLogout} from "@/store/auth/action";
import { normalizeText } from '@/utils';

const defaultOptions = {
	headers: {
		'Content-Type': 'application/json'
	}
};

const instance = axios.create(defaultOptions);
if (process.env.REACT_APP_STATE === 'local') {
	instance.defaults.baseURL = "http://localhost:3000"
} else if (process.env.REACT_APP_STATE === "production") {
	instance.defaults.baseURL = "https://api.jayaprana.id"
} else if (process.env.REACT_APP_STATE === "development") {
	instance.defaults.baseURL = 'https://api-staging.jayaprana.id'
} else {
	instance.defaults.baseURL = '/api'
}

instance.interceptors.request.use((config) => {
	const token = localStorage.getItem('access_token')
	if (token && !config.headers.Authorization) {
		// eslint-disable-next-line no-param-reassign
		config.headers.Authorization = `Bearer ${token}`
	}
	return config
}, error => Promise.reject(error))
instance.interceptors.response.use(
	(response) => response,
	(error) => {
		if (error.response.status === 401) {
			toast.error(normalizeText(error.response.data.message))
			store.dispatch(userLogout({}))
			return Promise.reject(error);
		}
		if (error.response.config.method === 'put' || error.response.config.method === 'patch' || error.response.config.method === 'post') {
			toast.error(normalizeText(error.response.data.message))
		}
		return Promise.reject(error);
	}
);

export default instance
